import { useState } from "react";
import axiosClient from "../api/axiosClient";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import "./admin.css";
import "./AdminLogin.css";
import "../pages/auth/Auth.css";

function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    try {
      const res = await axiosClient.post("/auth/login", form);

      if (!res.data || !res.data.token || !res.data.user) {
        toast.error("Invalid response from server");
        setLoading(false);
        return;
      }

      const user = res.data.user;

      // 🔒 Admin-only check
      if (user.role !== "admin") {
        toast.error("Access denied — Admin only");
        setLoading(false);
        return;
      }

      // ✅ Store ONE token system using central AuthContext
      login(user, res.data.token);

      navigate("/admin/dashboard");

    } catch (error) {
      toast.error("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <h2>Admin Login</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            className="admin-input"
          placeholder="Admin Email"
          value={form.email}
          onChange={(e) =>
            setForm({ ...form, email: e.target.value })
          }
          required
        />

          <input
            type="password"
            className="admin-input"
          placeholder="Password"
          value={form.password}
          onChange={(e) =>
            setForm({ ...form, password: e.target.value })
          }
          required
        />

          <button className="btn btn-primary" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>

          <p
            className="fp-link fp-link-admin"
            onClick={() => navigate("/forgot-password")}
          >
            Forgot Password?
          </p>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
